import React from 'react';

function Privacy() {
  return (
    <div className="bg-gray-50 min-h-screen py-10 px-6 sm:px-12 lg:px-32">
      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-8">
        <h1 className="text-2xl font-semibold text-gray-800 mb-6 border-b pb-4">
          Privacy Policy di Zanca snc
        </h1>
        <p className="text-gray-700 mb-6">
          La protezione dei tuoi dati personali è una priorità per Zanca snc. La presente informativa sulla privacy descrive come raccogliamo, utilizziamo, conserviamo e proteggiamo i tuoi dati personali quando visiti il nostro sito web [inserire URL del sito] e utilizzi i nostri servizi.
        </p>
        <div className="space-y-6">
          <div>
            <h2 className="text-lg font-medium text-gray-800 mb-2">Titolare del Trattamento</h2>
            <p className="text-gray-700">
              Il titolare del trattamento dei dati è Zanca snc con sede in Via G. Verdi 3, Porto Mantovano (MN). Puoi contattarci via e-mail all'indirizzo zanca.snc@gmail.com o al numero di telefono 0376 398705.
            </p>
          </div>
          <div>
            <h2 className="text-lg font-medium text-gray-800 mb-2">Tipologie di Dati Raccolti</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              <li>Dati forniti volontariamente dall'utente: quando compili il modulo di contatto per richiedere informazioni o un preventivo, raccogliamo il tuo nome, indirizzo e-mail e il messaggio che invii.</li>
              <li>Dati di navigazione: informazioni generali sulle tue attività di navigazione (ad esempio, indirizzo IP, browser utilizzato, tempi di accesso, ecc.), che possono essere raccolte tramite cookie tecnici (se utilizzati).</li>
            </ul>
          </div>
          <div>
            <h2 className="text-lg font-medium text-gray-800 mb-2">Modalità di Raccolta dei Dati</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              <li>Modulo di contatto: quando compili il modulo per richiedere informazioni o un preventivo, i dati vengono inviati direttamente a zanca.snc@gmail.com tramite il servizio EmailJS.</li>
              <li>Dati di navigazione: I dati relativi alla navigazione (indirizzo IP, tipo di browser, ecc.) vengono raccolti automaticamente tramite l'uso di cookie tecnici.</li>
            </ul>
          </div>
          <div>
            <h2 className="text-lg font-medium text-gray-800 mb-2">Finalità del Trattamento</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              <li>Rispondere alle richieste degli utenti: utilizziamo i tuoi dati (nome, e-mail, messaggio) per rispondere alle richieste inviate tramite il modulo di contatto.</li>
              <li>Migliorare il sito: i dati di navigazione possono essere utilizzati per analizzare come gli utenti interagiscono con il sito e per migliorare la funzionalità del sito web.</li>
            </ul>
          </div>
          <div>
            <h2 className="text-lg font-medium text-gray-800 mb-2">Base Giuridica per il Trattamento</h2>
            <p className="text-gray-700">
              Il trattamento dei dati personali avviene sulla base del consenso dell'utente (quando compili il modulo di contatto) e per l'esecuzione di un contratto (fornire le informazioni richieste via e-mail).
            </p>
          </div>
          <div>
            <h2 className="text-lg font-medium text-gray-800 mb-2">Condivisione dei Dati con Terze Parti</h2>
            <p className="text-gray-700">
              I tuoi dati personali non vengono condivisi con terze parti, ad eccezione di EmailJS, che è il servizio utilizzato per inviare le e-mail tramite il modulo di contatto. EmailJS gestisce i dati in conformità con la propria politica sulla privacy, che puoi consultare sul loro sito.
            </p>
          </div>
          <div>
            <h2 className="text-lg font-medium text-gray-800 mb-2">Diritti dell'Utente</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              <li>Accedere ai tuoi dati personali.</li>
              <li>Rettificare o cancellare i tuoi dati.</li>
              <li>Opporsi al trattamento dei tuoi dati per scopi di marketing.</li>
              <li>Revocare il consenso in qualsiasi momento.</li>
              <li>Portabilità dei dati, se applicabile.</li>
            </ul>
            <p className="text-gray-700">
              Per esercitare questi diritti, puoi inviarci una richiesta a zanca.snc@gmail.com.
            </p>
          </div>
          <div>
            <h2 className="text-lg font-medium text-gray-800 mb-2">Modifiche alla Privacy Policy</h2>
            <p className="text-gray-700">
              Questa privacy policy potrebbe essere aggiornata periodicamente. In caso di modifiche sostanziali, gli utenti saranno informati tramite il sito web o via e-mail.
            </p>
          </div>
          <div>
            <h2 className="text-lg font-medium text-gray-800 mb-2">Contatti</h2>
            <p className="text-gray-700">
              Per qualsiasi domanda o richiesta relativa alla privacy, contattaci a:
            </p>
            <p className="text-gray-700">Email: zanca.snc@gmail.com</p>
            <p className="text-gray-700">Telefono: 0376 398705</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
